import React, { useCallback, useEffect } from 'react';

export const IQCAdminAppContext = React.createContext<any>({});

export const IQCAdminApp = ({ children, containerRef }) => {
  const scrollToTop = useCallback(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo(0, 0);
    } else {
      document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [containerRef]);

  return (
    <IQCAdminAppContext.Provider
      value={{
        scrollToTop,
      }}
    >
      {children}
    </IQCAdminAppContext.Provider>
  );
};
